"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MenuItem = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, _extends({}, props, {
    ref: ref
  }));
});

var _default = MenuItem;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lbnUvTWVudUl0ZW0udHN4Il0sIm5hbWVzIjpbIk1lbnVJdGVtIiwiUmVhY3QiLCJmb3J3YXJkUmVmIiwicHJvcHMiLCJyZWYiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7Ozs7Ozs7QUFPQSxJQUFNQSxRQUFpQyxnQkFBR0MsZUFBTUMsVUFBTixDQUFpQixVQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxzQkFBZ0IsNkJBQUMsaUJBQUQsZUFBaUJELEtBQWpCO0FBQXdCLElBQUEsR0FBRyxFQUFFQztBQUE3QixLQUFoQjtBQUFBLENBQWpCLENBQTFDOztlQUVlSixRIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IE1lbnVJdGVtIGFzIE11aU1lbnVJdGVtLCBNZW51SXRlbVByb3BzIGFzIE11aU1lbnVJdGVtUHJvcHMgfSBmcm9tICdAbWF0ZXJpYWwtdWkvY29yZSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgTWVudUl0ZW1Qcm9wcyBleHRlbmRzIE9taXQ8TXVpTWVudUl0ZW1Qcm9wcywgJ2J1dHRvbic+IHtcbiAgYnV0dG9uPzogdHJ1ZTtcbn1cblxuY29uc3QgTWVudUl0ZW06IFJlYWN0LkZDPE1lbnVJdGVtUHJvcHM+ID0gUmVhY3QuZm9yd2FyZFJlZigocHJvcHMsIHJlZikgPT4gPE11aU1lbnVJdGVtIHsuLi5wcm9wc30gcmVmPXtyZWZ9IC8+KTtcblxuZXhwb3J0IGRlZmF1bHQgTWVudUl0ZW07XG4iXX0=